export const nivotheme = (theme) => ({
    textColor:
        theme.colorScheme == "dark"
            ? theme.colors.dark[2]
            : theme.colors.dark[6],

    tooltip: {
        container: {
            background: "#ffffff",
            color: "#333333",
        },
    },
    grid: {
        line: {
            stroke:
                theme.colorScheme == "dark"
                    ? theme.colors.dark[4]
                    : theme.colors.gray[3],
            strokeWidth: 1,
        },
    },
});
